import React from 'react'
import { Card, Col, Row, Image, Button } from 'react-bootstrap';
import styled from 'styled-components';
import CircleImage from '../CircleImage';
import MultiLineEllipse from '../MultiLineEllipse';
import parse from "html-react-parser";
import { useHistory } from 'react-router';

const JobTitle = styled.div`
    text-transform: uppercase;
    font-weight: 600;
    color: #23268E;
    text-align: center;
    margin-top:2%;
    margin-bottom:5%;
`;

const JobsButton = styled(Button)`
    position: absolute;
    margin-left: 19%;
    margin-top: 3%;
    border: none;
    background-color: white;
    color: black;
    font-size: 12px;
    font-weight: 600;
    width: 50%;
    border: 1px solid darkblue;
`;

function JobTile({ TileData, maxLine }) {

    const history = useHistory();

    return (
        <Card style={{ width: '15rem', marginBottom: '20px' }}>
        <Card.Body>
            <Row>
                <Col>
                    <CircleImage style={{marginLeft:'25%'}}/>
                </Col>
            </Row>  
        </Card.Body>
        <Card.Footer style={{paddingBottom: '25px', backgroundColor: '#CACACA'}}>
            <Row>
                <Col>
                    <JobTitle> {TileData.Title} </JobTitle>
                </Col>
            </Row>
            <MultiLineEllipse maxLine={maxLine}>
                <p style={{color: '#23268E'}}>{parse(TileData?.Description)}</p>
            </MultiLineEllipse>
            <JobsButton onClick={() => { history.push('/job/' + TileData.JobId)}}>APPLY NOW</JobsButton> 
        </Card.Footer>
    </Card>     
    )
}

JobTile.propTypes = {
    // Company: PropTypes.string,
    // Logo: PropTypes.string,
    // Description: PropTypes.string,
    // Link: PropTypes.string
}

export default JobTile

